/**
 * Fulfillment回显组件
 * 展示订单商品的 fulfillment 服务信息：包装服务、条码定制、其他要求说明
 *
 * Copyright 2016, all rights reserved. Essa.cn
 */
import React from "react";
import { Image } from "antd";
import Lang from "@components/Lang/Lang";
import PopSetFulfillment from "../popSetFulfillment/popSetFulfillment";
import "./index.less";

const ImagePreviewGroup = Image.PreviewGroup;

class FulfillmentDisplay extends React.Component {
    static defaultProps = {
        requireResultVO: null,
        item: null, //
    };

    /**
     * 检查文件是否为PDF格式
     * @param {string} url - 文件URL
     * @returns {boolean} 是否为PDF
     */
    isPDFFile = (url) => {
        if (!url) return false;
        const fileName = url.split('/').pop().split('?')[0];
        return fileName.toLowerCase().endsWith('.pdf');
    };
    refresh(){
        if(this.props.refresh){
            this.props.refresh()
        }
    }
    /**
     * 打开PDF预览
     * @param {string} url - PDF文件URL
     */
    openPDFPreview = (url) => {
        if (!url) return;
        window.open(url);
    };

    render() {
        const { requireResultVO={},bgYellow,styleName,poItem } = this.props;
        const fulfillmentVO = requireResultVO&&requireResultVO.fulfillmentVO || {};
        const barcodeRequireList = requireResultVO&&requireResultVO.barcodeRequireList || [];
        const otherRequireList = requireResultVO&&requireResultVO.otherRequireList || [];
        const hasFulfillment = fulfillmentVO && (fulfillmentVO.serviceCodeName || fulfillmentVO.serviceItemCodeName);
        const hasBarcode = barcodeRequireList.length > 0;
        const hasOther = otherRequireList.length > 0;
        // canUpdateRequire 1 可编辑&新增生产要求
        return ((!poItem.canUpdateRequire&&!hasFulfillment && !hasBarcode && !hasOther)?null:
            <div className={`fulfillment-display-wrap ${bgYellow ? " bpPicturePreview" : ""}${styleName?' '+styleName:''}`}>
                <div className="titlePicturePreview flex-item-between">
                    {__getServerLanguage("FufilmentKey2")}
                    {/* 修改 */}
                    {poItem.canUpdateRequire?<PopSetFulfillment barcodeRequireList={barcodeRequireList}
                                       poItem={poItem}
                                       refresh={()=>this.refresh()}
                                       otherRequireList={otherRequireList}>
                        <span className={"font-main2 cursor-p"}>
                           {(!hasFulfillment && !hasBarcode && !hasOther)?Lang({id: 'XinZeng', default: '新增'}):Lang({id: 'XiuGai', default: '修改'})}
                        </span>
                    </PopSetFulfillment>:null}
                </div>
                <div className="require-content">
                    {/* 额外包装要求 */}
                    {hasFulfillment && (
                        <div className="require-section" style={{ position: "relative" }}>
                            <h4>{__getServerLanguage("EwaiBaoZhuangYaoQiu")}</h4>
                            <div className="packaging-info margin-top-5">
                                <div className="flex-item">
                                    {fulfillmentVO.serviceCodeName && (
                                        <div className="black66">{fulfillmentVO.serviceCodeName}</div>
                                    )}
                                    {/*{fulfillmentVO.serviceItemCodeName && (*/}
                                        {/*<div className="redColor margin-left-5">*/}
                                            {/*| {fulfillmentVO.serviceItemCodeName}*/}
                                        {/*</div>*/}
                                    {/*)}*/}
                                </div>
                                {/*{fulfillmentVO.supplierCost && (*/}
                                    {/*<div className="margin-top-5 redColor">*/}
                                        {/*¥{fulfillmentVO.supplierCost}*/}
                                    {/*</div>*/}
                                {/*)}*/}
                            </div>
                        </div>
                    )}

                    {/* 条形码定制 */}
                    {hasBarcode && (
                        <div className="require-section barScroll" style={!hasFulfillment&&!hasOther?{flex: 1,maxWidth: '100%'}:{}}>
                            <h4>
                                {__getServerLanguage("TiaoXingMaDingZhi")} ({barcodeRequireList.length})
                            </h4>
                            <div className="barcode-section-display">
                                <ImagePreviewGroup>
                                    {barcodeRequireList.map((barcode, idx) => (
                                        <div key={idx} className="barcode-item">
                                            {barcode.productRequireFileUrl && (
                                                <div className="file-preview">
                                                    {this.isPDFFile(barcode.productRequireFileUrl) ? (
                                                        <div
                                                            className="pdf-icon-wrapper"
                                                            style={{
                                                                width: '40px',
                                                                height: '40px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                background: '#fff',
                                                                borderRadius: '4px',
                                                                cursor: 'pointer',
                                                                color: '#ff4d4f',
                                                            }}
                                                            onClick={() =>
                                                                this.openPDFPreview(barcode.productRequireFileUrl)
                                                            }
                                                        >
                                                            <Image
                                                            src={'https://oss.essaone.com/d0e08dda-d12c-499b-b08a-72e5b504cad1.svg'}
                                                            alt={barcode.productRequireNotCn || ""}
                                                                width={40}
                                                                height={40}
                                                                preview={false}
                                                                style={{ cursor: "pointer" }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <Image
                                                            src={barcode.productRequireFileUrl}
                                                            alt={barcode.productRequireNotCn || ""}
                                                            width={40}
                                                            height={40}
                                                            style={{ cursor: "pointer" }}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                            {barcode.productRequireNotCn && (
                                                <div className="barcode-desc">{barcode.productRequireNotCn}</div>
                                            )}
                                        </div>
                                    ))}
                                </ImagePreviewGroup>
                            </div>
                        </div>
                    )}

                    {/* 其他要求说明 */}
                    {hasOther && (
                        <div className="require-section flex-1">
                            <h4>{__getServerLanguage("QiTaYaoQiuShuoMing") || "其他要求说明"}</h4>
                            {otherRequireList.map((otherRequire, idx) => (
                                    <div key={idx} className="other-requirement">
                                        {otherRequire.productRequireFileList &&
                                            otherRequire.productRequireFileList.length > 0 && (
                                                <div className="images">
                                                    <ImagePreviewGroup>
                                                        {otherRequire.productRequireFileList.map((file, fileIdx) => (
                                                            <div key={fileIdx}>
                                                                {this.isPDFFile(file.fileUrl) ? (
                                                                    <div
                                                                        className="pdf-icon-wrapper"
                                                                        style={{
                                                                            width: '40px',
                                                                            height: '40px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            background: '#fff',
                                                                            borderRadius: '4px',
                                                                            cursor: 'pointer',
                                                                            color: '#ff4d4f',
                                                                        }}
                                                                        onClick={() =>
                                                                            this.openPDFPreview(file.fileUrl)
                                                                        }
                                                                    >
                                                                        <Image
                                                                            src={'https://oss.essaone.com/d0e08dda-d12c-499b-b08a-72e5b504cad1.svg'}
                                                                            alt={file.fileUrl || ""}
                                                                                width={40}
                                                                                height={40}
                                                                                preview={false}
                                                                                style={{ cursor: "pointer" }}
                                                                            />
                                                                    </div>
                                                                ) : (
                                                                    <Image
                                                                        src={file.fileUrl}
                                                                        alt={__getServerLanguage("YaoQiuShuoMing") || "要求说明"}
                                                                        width={40}
                                                                        height={40}
                                                                        style={{ cursor: "pointer" }}
                                                                    />
                                                                )}
                                                            </div>
                                                        ))}
                                                    </ImagePreviewGroup>
                                                </div>
                                            )}
                                        <div className="description">
                                            {otherRequire.productRequireNotCn && (
                                                <div className="ellipsis-line2">{otherRequire.productRequireNotCn}</div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default FulfillmentDisplay;
